/* LiftPro — бейдж "Fits your vehicle" на карточках каталога.
 * Читает выбранную машину (localStorage liftpro_vehicle) и помечает карточки,
 * чей data-fit-tags содержит fit_<generation>. Работает на любых сетках:
 * коллекции, поиск, featured, related. */
(function () {
  "use strict";

  function currentGen() {
    try {
      var v = JSON.parse(localStorage.getItem("liftpro_vehicle") || "null");
      return v && v.gen ? "fit_" + v.gen : null;
    } catch (e) {
      return null;
    }
  }

  function apply() {
    var fitTag = currentGen();
    document.querySelectorAll("[data-fit-tags]").forEach(function (card) {
      var has = card.querySelector(".lp-fit-badge");
      var match = fitTag && (" " + card.getAttribute("data-fit-tags") + " ")
        .indexOf(" " + fitTag + " ") !== -1;
      if (match && !has) {
        var b = document.createElement("span");
        b.className = "lp-fit-badge";
        b.textContent = "Fits your vehicle";
        card.appendChild(b);
      } else if (!match && has) {
        has.remove();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
  // сетки перерисовываются фильтрами (Section Rendering) — следим
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { apply(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener("storage", apply);
})();
